import MouseEmitter from '../ninjas/MouseParticles/MouseEmitter';
import Game from '../scenes/Game';

export default class SpritePool {
  /**
   * 
   * @param {*} type 
   * @param {number} length 
   * @param {Game | MouseEmitter} emitter 
   */
  constructor (type, length, emitter) {
    this.pool = [];
    let i = length;
    while (--i > -1) {
      // eslint-disable-next-line new-cap
      this.pool[i] = new type(emitter instanceof Game ? emitter : emitter.scene);
    }
  }

  getSprite () {
    if (this.pool.length > 0) {
      return this.pool.pop();
    }
    return null;
  }

  returnSprite (sprite) {
    this.pool.push(sprite);
  }
}